<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="title-page"><span class="title">&nbsp;</span>

  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    
    <div nz-row [nzGutter]="24">
  
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Loại khuyết tật</nz-form-label>
          <asc-autocomplete [ascModel]="typeOfDisabilitysControl" (ascModelChange)="changeTypeOfDisabilitys($event)"
            [placeholder]="'Chọn loại khuyết tật'" [getListAC]="getTypeOfDisabilitysACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="ma" >Mã giáo viên</nz-form-label>
          <nz-form-control nzSpan="24">
            <input type="text" nz-input [(ngModel)]="commonFilter.StaffCode" [ngModelOptions]="{standalone: true}" />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="ma">Họ tên</nz-form-label>
          <nz-form-control nzSpan="24">
            <input nz-input [(ngModel)]="commonFilter.FullName" [ngModelOptions]="{standalone: true}"
              placeholder="Nhập họ tên..." />
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Loại nhân sự</nz-form-label>
          <asc-autocomplete [ascModel]="typeOfPersonnelControl" (ascModelChange)="changeTypeOfPersonnel($event)"
            [placeholder]="'Chọn loại nhân sự'" [getListAC]="getTypeOfPersonnelACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="24" nzLg="24" nzXl="24">
        <div style="visibility: hidden; margin-top: 5px">i</div>
      </div>
    </div>
    <div nz-row>

      <div nz-col [nzSpan]="24" class="search-area"> 
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="search()">Tìm
            kiếm</button>
        </ng-container>
        <!-- <ng-container *ngIf="btnType === buttonTypeEnum.ICON"> -->
        <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
          nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i nz-icon nzType="search"
            nzTheme="outline"></i></button>
        <!-- </ng-container> -->
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">

          <button nz-button class="flex items-center justify-center" [nzType]="'primary'"><i nz-icon nzType="search"
              nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="staffList" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full" [nzFrontPagination]="false"
      [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)"
      (nzCurrentPageDataChange)="onCurrentPageDataChange($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzLeft nzWidth="50px" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"></th>
          <th nzWidth="50px" nzLeft>STT</th>
          <th>Mã nhân sự</th>
          <th>Họ tên</th>
          <th>Ngày sinh</th>
          <th>Giới tính</th>
          <th>Loại nhân sự</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of Table.data; let i = index">
          <td nzLeft [nzChecked]="setOfCheckedId.has(item.id)" (nzCheckedChange)="onItemChecked(item.id, $event)"></td>
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td>{{item.staffCode}}</td>
          <td>{{item.fullName}}</td>
          <td>{{item.dayOfBirth | date:'dd/MM/yyyy'}}</td>
          <td>{{item.gender | gender}}</td>
          <td>{{item.typeOfPersonnelName}} </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<div *nzModalFooter>
  <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>
  <button nz-button nzType="primary" (click)="chooseSchool()">Chọn</button>
</div>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>